module.exports = __webpack_public_path__ + "img/icon-coffee-bean.f976b698.svg";